import { useParams } from 'react-router-dom';
import { all } from '../data/all';
import NotFound from './NotFound';
import CountryRender from './CountryRender';

function CountryView() {
    const { continent } = useParams();

    let countriesData = [];

    all.forEach(thisCountry => {
        if (thisCountry.region === continent) {
            countriesData = [...countriesData, thisCountry];
        }
    })

    countriesData.sort(function(a, b) {
        return a.name.common > b.name.common;
    });

    if (countriesData.length === 0) {
        return (
            <NotFound />
        )
    } else {
        return (
            countriesData.map(countryData => 
                <CountryRender data={countryData} />
            )
        )
    }
}

export default CountryView;